import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getApiHost } from '../../../../app/infrastructure/http/apiClient';
import { unwrapSearchData } from '../../application/mapSearch';
import type { SearchListResponse, SearchParams } from '../../application/types';

function authorizationHeader(token?: string | null): string | undefined {
  if (!token) return undefined;
  return token.startsWith('Bearer ') ? token : `Bearer ${token}`;
}

function apiBaseUrl(): string {
  const host = getApiHost();
  return host.endsWith('/') ? host : `${host}/`;
}

export const searchApi = createApi({
  reducerPath: 'searchApi',
  baseQuery: fetchBaseQuery({
    baseUrl: apiBaseUrl(),
    credentials: 'include',
    prepareHeaders: (headers, { getState }) => {
      const token = (
        getState() as { authorization?: { accessToken?: string | null } }
      ).authorization?.accessToken;
      const value = authorizationHeader(token);
      if (value) headers.set('Authorization', value);
      return headers;
    },
  }),
  endpoints: (build) => ({
    search: build.query<SearchListResponse, SearchParams>({
      query: ({ q, type, page = 1, limit = 10, mode = 'full' }) => ({
        url: `search/${encodeURIComponent(q || '*')}`,
        method: 'GET',
        params: {
          ...(type ? { type } : {}),
          page,
          limit,
          mode,
        },
      }),
      transformResponse: unwrapSearchData,
    }),
  }),
});

export const { useLazySearchQuery, useSearchQuery } = searchApi;
